<ng-template #separator>
  <div class="min-w-7 w-7 px-0.5">
    <div class="separator-border w-px h-full ml-[50%]"></div>
  </div>
</ng-template>

<div @slideIn class="history-wrapper flex flex-col">
  <div class="flex justify-between px-4 min-h-14 bg-navy-100 border-y border-solid border-navy-200 items-center">
    <div class="font-bold text-size_title_s text-navy-900">Budget History</div>
    <app-simple-button
      size="large"
      class="gap-1"
      [ngClass]="{ disabled: isLoading() }"
      (click)="openBudgetLog()"
      [wrapperClass]="{ 'px-2.5 w-40': true }"
    >
      <div class="flex items-center justify-between w-full">
        <span> View Budget Log</span>
        <span class="icon-view text-size_icon"></span>
      </div>
    </app-simple-button>
  </div>

  @if (isLoading()) {
    <div class="loading-content">
      <div class="notify-msg animate-pulsating-border">
        <div class="icon-logo-box-hex"></div>
      </div>
    </div>
  } @else {
    <ng-scrollbar appearance="compact" orientation="auto" class="std-scrollbar flex-1">
      <div class="flex flex-col">
        <div class="flex text-navy-600 font-bold text-size_xs uppercase pt-5 top-0 sticky bg-color-white">
          <div class="min-w-56 w-56 mb-1.5">Budget Lines</div>
          <ng-template *ngTemplateOutlet="separator"></ng-template>

          <div class="min-w-32 w-32 -mr-0.5 mb-1.5">Current Budget</div>
          <ng-template *ngTemplateOutlet="separator"></ng-template>

          @for (date of dates(); let index = $index; track index) {
            <div class="flex">
              <span class="min-w-32 w-32 -mr-0.5 mb-1.5">{{ date }} Budget</span>
              <ng-template *ngTemplateOutlet="separator"></ng-template>
            </div>
          }

          <div class="min-w-32 w-32 -mr-0.5 mb-1.5">Original Budget</div>
          <ng-template *ngTemplateOutlet="separator"></ng-template>
        </div>
        <!--      <ng-scrollbar visibility="always" appearance="compact" orientation="vertical" class="std-scrollbar">-->
        <div class="flex flex-col h-full flex-1">
          @for (item of lineItems(); track item.id) {
            <div class="flex">
              <app-floating-input
                class="min-w-56 w-56 spend-input-bg"
                [disabled]="true"
                [verticalSpacing]="false"
                [(ngModel)]="item.name"
                [name]="'checklistInput_' + item.id"
              ></app-floating-input>
              <ng-template *ngTemplateOutlet="separator"></ng-template>

              <app-spend-custom-input
                class="min-w-28 w-28 border-box"
                [disabled]="true"
                [allowNegatives]="true"
                [value]="item.current_budget"
              />
              <ng-template *ngTemplateOutlet="separator"></ng-template>

              @for (adjust of item.adjustments; let index = $index; track index) {
                <app-spend-custom-input
                  class="min-w-28 w-28 border-box"
                  [disabled]="true"
                  [allowNegatives]="true"
                  [value]="adjust.value"
                />
                <ng-template *ngTemplateOutlet="separator"></ng-template>
              }

              <app-spend-custom-input
                class="min-w-28 w-28 border-box"
                [disabled]="true"
                [allowNegatives]="true"
                [value]="item.original_budget"
              />
              <ng-template *ngTemplateOutlet="separator"></ng-template>
            </div>
          }

          <div class="flex font-bold text-navy-900 text-xs flex-1 pb-5">
            <div class="min-w-56 w-56"></div>
            <ng-template *ngTemplateOutlet="separator"></ng-template>

            <div
              class="min-w-32 w-32 -mr-0.5 pl-4 pt-2.5 box-border"
              [ngClass]="{ negative: totals().current_budget < 0 }"
            >
              $ {{ Math.abs(totals().current_budget) | money: 'comaNoZero' }}
            </div>
            <ng-template *ngTemplateOutlet="separator"></ng-template>

            @for (adjust of totals().adjustments; let index = $index; track index) {
              <div class="flex">
                <span class="min-w-32 w-32 -mr-0.5 pl-4 pt-2.5 box-border" [ngClass]="{ negative: adjust.value < 0 }"
                  >$ {{ Math.abs(adjust.value) | money: 'comaNoZero' }}</span
                >
                <ng-template *ngTemplateOutlet="separator"></ng-template>
              </div>
            }

            <div
              class="min-w-32 w-32 -mr-0.5 pl-4 pt-2.5 box-border"
              [ngClass]="{ negative: totals().original_budget < 0 }"
            >
              $ {{ Math.abs(totals().original_budget) | money: 'comaNoZero' }}
            </div>
            <ng-template *ngTemplateOutlet="separator"></ng-template>
          </div>
        </div>
      </div>
      <!--      </ng-scrollbar>-->
    </ng-scrollbar>

    <div class="flex items-center h-20 border-t border-solid border-navy-300">
      <app-simple-button
        size="large"
        [wrapperClass]="{
          'bg-color-white border rounded border-solid border-blue-700 text-blue-700 text-sm font-semibold': true,
        }"
        class="flex ml-auto"
        (click)="closeView()"
      >
        Close
      </app-simple-button>
    </div>
  }
</div>
